<template>
  <div style="margin-bottom: 0.2rem;">
    <b-card no-body class="overflow-hidden">
      <b-row no-gutters align-v="center" style=" margin: auto;">
        <b-col cols="6" sm="12">
          <b-card-img-lazy img-left blank-src="/cover_place_holder.png" :src="this.game.cover ? this.url : ''" :alt="this.game.name + ' cover image'"></b-card-img-lazy>
        </b-col>
        <b-col cols="6" sm="12">
          <b-card-body style="max-width: 20rem;" class="mb-2 game-card block-ellipsis">
            <b-card-title class="block-ellipsis">{{this.game.name}}</b-card-title>
            <b-card-sub-title>{{'Release date: ' + this.releaseDate.formattedDate}}</b-card-sub-title>
            <b-button style="margin-top: 0.8rem;" variant="outline-light" :href="'/game/name/' + this.game.slug">See more!</b-button>
          </b-card-body>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'gamecard',
  props: ['releaseDate'],
  computed: {
    game: function () {
      return this.releaseDate.game
    },
    url: function () {
      // site breaks on cover undefined
      return this.game.cover.url ? this.game.cover.url.replace('thumb', 'original') : ''
    }
  }
}
</script>

<style>
.game-card {
  text-align: left;
  padding-bottom: 0.5rem;
}
.block-ellipsis {
  display: block;
  display: -webkit-box;
  max-width: 100%;
  height: 100%;
  margin: 0 auto;
  font-size: 1.3rem;
  line-height: 1.2;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
